// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__FxJ5j","fillColor":"IconSuccess_fillColor__3i80D"};